import { ModuleAccessGuard } from '@/components/ModuleAccessGuard';

export default function APIAccess() {
  return (
    <ModuleAccessGuard moduleId="api">
      <div className="space-y-8">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">API Access</h1>
          <p className="text-muted-foreground mt-2">
            REST API and webhook access for system integration.
          </p>
        </div>
        <div className="text-center text-muted-foreground">
          API management interface coming soon.
        </div>
      </div>
    </ModuleAccessGuard>
  );
}